// extracted by mini-css-extract-plugin
export default {"subsectionRow":"ControversiesTable_subsectionRow__+eD8f","subsectionCell":"ControversiesTable_subsectionCell__Ve+1R"};